export const filterEstateById = (estateList, id) => {
  return estateList
    .filter((estate) => estate.id === id)
    .reduce((accumulator, currentValue) => currentValue || accumulator, {
      mDMEstate: { mDMMeterPointList: [] },
    });
};

export const filterMeterPointById = (meterPointList, id) => {
  return meterPointList
    .filter((meterPoint) => meterPoint.id === id)
    .reduce((accumulator, currentValue) => currentValue || accumulator, {
      mDMMeterRegisterList: [],
    });
};

export const filterMeterById = (meterRegisterList, id) => {
  return meterRegisterList
    .filter(({ meter }) => meter.id === id)
    .reduce((accumulator, currentValue) => currentValue || accumulator, { meter: '' }).meter;
};

export const getUniqueMeters = (meterRegisterList) => {
  return meterRegisterList
    .map(({ meter }) => meter)
    .filter((meter, index, self) => {
      return self.findIndex((m) => m.id === meter.id) === index;
    });
};
